import { createReducer, on } from '@ngrx/store';

import { ProjectDataActions } from './project-data.actions';
import { ProjectDataState, initialState } from './project-data.state';

export const reducer = createReducer(
  initialState,
  on(
    ProjectDataActions.create_project_start,
    (state: ProjectDataState): ProjectDataState => ({
      ...state,
      projectEntities: null,
      projectActions: [],
      latestCreatedId: null,
      loading: true,
      latestActionCausedError: false
    })
  ),
  on(ProjectDataActions.create_project_success, (state, data) => {
    return {
      ...state,
      latestCreatedId: data.createdId,
      loading: false
    };
  }),
  on(
    ProjectDataActions.create_project_fail,
    (state): ProjectDataState => ({
      ...state,
      projectEntities: null,
      projectActions: [],
      latestCreatedId: null,
      loading: false,
      latestActionCausedError: true
    })
  ),
  on(
    ProjectDataActions.get_project_start,
    (state: ProjectDataState): ProjectDataState => ({
      ...state,
      loading: true,
      latestActionCausedError: false,
      projectLoaded: false
    })
  ),
  on(
    ProjectDataActions.update_project_start,
    (state: ProjectDataState): ProjectDataState => ({
      ...state,
      loading: true,
      latestActionCausedError: false
    })
  ),

  on(ProjectDataActions.get_project_success, (state, data): ProjectDataState => {
    return {
      ...state,
      projectEntities: data.entities,
      loading: false,
      projectLoaded: true
    };
  }),
  on(ProjectDataActions.update_project_success, (state, data): ProjectDataState => {
    return {
      ...state,
      projectEntities: data.updatedEntities,
      loading: false
    };
  }),
  on(ProjectDataActions.update_project_actions, (state, data): ProjectDataState => {
    return {
      ...state,
      projectActions: data.projectActions
    };
  }),
  on(
    ProjectDataActions.update_project_fail,
    ProjectDataActions.get_project_fail,
    (state): ProjectDataState => ({
      ...state,
      projectEntities: null,
      projectActions: [],
      loading: false,
      latestActionCausedError: true
    })
  ),
  on(
    ProjectDataActions.create_entity_start,
    (state): ProjectDataState => ({
      ...state,
      latestCreatedId: null,
      latestActionCausedError: false
    })
  ),
  on(ProjectDataActions.create_entity_success, (state, data): ProjectDataState => {
    return {
      ...state,
      latestCreatedId: data.createdId
    };
  }),
  on(
    ProjectDataActions.create_entity_fail,
    (state): ProjectDataState => ({
      ...state,
      latestCreatedId: null,
      latestActionCausedError: true
    })
  ),
  on(
    ProjectDataActions.reset_latest_created_id,
    (state): ProjectDataState => ({
      ...state,
      latestCreatedId: null,
      latestCopiedEntityParentId: null
    })
  ),
  on(
    ProjectDataActions.copy_entity_start,
    (state): ProjectDataState => ({
      ...state,
      latestCopiedId: null,
      latestCopiedEntityParentId: null
    })
  ),
  on(ProjectDataActions.copy_entity_success, (state, data): ProjectDataState => {
    return {
      ...state,
      latestCopiedId: data.copiedId,
      latestCopiedEntityParentId: data.parentId
    };
  }),
  on(
    ProjectDataActions.copy_entity_fail,
    (state): ProjectDataState => ({
      ...state,
      latestCopiedId: null,
      latestCopiedEntityParentId: null,
      latestActionCausedError: true
    })
  ),
  on(
    ProjectDataActions.reset_latest_copied_id,
    (state): ProjectDataState => ({
      ...state,
      latestCopiedId: null
    })
  ),
  on(
    ProjectDataActions.delete_entity_start,
    (state): ProjectDataState => ({
      ...state,
      latestDeletedIdList: []
    })
  ),
  on(ProjectDataActions.delete_entity_success, (state, data): ProjectDataState => {
    return {
      ...state,
      latestDeletedIdList: data.deletedIdList
    };
  }),
  on(
    ProjectDataActions.delete_entity_fail,
    (state): ProjectDataState => ({
      ...state,
      latestDeletedIdList: [],
      latestActionCausedError: false
    })
  ),
  on(
    ProjectDataActions.reset_latest_deleted_id,
    (state): ProjectDataState => ({
      ...state,
      latestDeletedIdList: []
    })
  ),
  on(
    ProjectDataActions.initialize_action,
    (state): ProjectDataState => ({
      ...state,
      actionInitialized: true
    })
  ),
  on(
    ProjectDataActions.reset_initialize_action,
    (state): ProjectDataState => ({
      ...state,
      actionInitialized: false
    })
  ),
  on(ProjectDataActions.set_last_selected_hood_id, (state, data): ProjectDataState => {
    return {
      ...state,
      lastSelectedHoodId: data.id
    };
  }),
  on(ProjectDataActions.set_last_selected_module_id, (state, data): ProjectDataState => {
    return {
      ...state,
      lastSelectedModuleId: data.id
    };
  }),
  on(ProjectDataActions.set_last_selected_entity_id, (state, data): ProjectDataState => {
    return {
      ...state,
      lastSelectedEntityId: data.id
    };
  }),
  on(ProjectDataActions.set_project_loaded, (state, data) => {
    return {
      ...state,
      projectLoaded: data.loaded
    };
  }),
  on(ProjectDataActions.set_hood_line_entities, (state, data) => {
    return {
      ...state,
      temporaryHoodlineEntities: data.entities
    };
  })
);
